<div >
  <div class="m-page-message-container" [ngClass]="getContainerClass()">
    <div class="a-page-message-icon">
      <i class="fi"
         [ngClass]="getIconClassName()"></i>
    </div>
    <div class="a-page-message-title">
      {{ headerText }}
    </div>
    <div class="a-page-message-content">
      <span class="a-page-message-text">
        {{contentText}}
      </span>
    </div>
    <div class="generateLink"
         *ngIf="showButton"
    >
      <a class="a-button-link" [href]="buttonUrl">
        {{buttonText}}
      </a>
    </div>
  </div>
</div>

